module.exports = __webpack_public_path__ + "static/img/bottomFloor.6fb64ab4.png";